import { adminApi } from '../../api/adminApi';
import { fromListResponse } from '../../api/listParams';

/**
 * Admin import history. listImports pages, sorts and filters on the server (POST
 * /imports/list, with useAdminListParams' listParams): one page of import summaries, newest
 * first, without each import's rows and log (an import's report reads its own doc, see
 * the users area's getUserImport). Responds { rows, total }.
 */
export const adminImportsApi = adminApi.injectEndpoints({
	endpoints: (builder) => ({
		listImports: builder.query({
			query: (listParams) => ({ url: '/imports/list', method: 'POST', body: listParams }),
			transformResponse: fromListResponse,
			providesTags: [{ type: 'ADMIN_IMPORT', id: 'LIST' }],
		}),
	}),
});

export const { useListImportsQuery } = adminImportsApi;
